import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '../../core/services/api.service';
import { ApiResponse } from '../../core/shared/classes/api';
import { EchangeDonnees } from '../classes/echange-donnees';


@Injectable()
export class EchangeDonneesService {

    constructor (private apiService: ApiService) {}

    fetchConfigurations(sortant?: true): Observable<ApiResponse> {
        return this.apiService.get('echange-donnees-configurations'
        + (sortant ? '/sortante/1' : '')
        );
    }

    saveConfigurations(configurations: {remove: Array<any>, update: Array<any>, insert: Array<any>}): Observable<ApiResponse> {
        return this.apiService.put('echange-donnees-configurations/saveMany', configurations);
    }

    fetchBureauxByDomain(domain: string): Observable<ApiResponse> {
        return this.apiService.get(`echange-donnees/bureaux/domain/${domain}`);
    }

    echange(echangeDonnees: EchangeDonnees, bureauId: string) {
        const data = {
            bureau_id: bureauId,
            echange_donnees: echangeDonnees.toJson()
        };

        return this.apiService.post(`echange`, data);
    }

}
